/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseOfferComponentInstanceDto } from '../models';
// @ts-ignore
import type { BaseOfferComponentInstanceItemDto } from '../models';
// @ts-ignore
import type { CreateOfferInstanceRequestDto } from '../models';
// @ts-ignore
import type { FailedOfferWorkflowActionEventDto } from '../models';
// @ts-ignore
import type { OfferAllowedTransitionDto } from '../models';
// @ts-ignore
import type { OfferComponentAssigneeDto } from '../models';
// @ts-ignore
import type { OfferComponentInstanceItemIdResponseDto } from '../models';
// @ts-ignore
import type { OfferInstanceDto } from '../models';
// @ts-ignore
import type { OfferInstanceIdDto } from '../models';
// @ts-ignore
import type { OfferInstanceTermErrorResponseDto } from '../models';
// @ts-ignore
import type { OfferInstanceTermRequestDto } from '../models';
// @ts-ignore
import type { OfferItemErrorResponseDto } from '../models';
// @ts-ignore
import type { OfferStatusTransitionRequestDto } from '../models';
// @ts-ignore
import type { OfferStatusTransitionResultDto } from '../models';
// @ts-ignore
import type { OfferTaskDto } from '../models';
// @ts-ignore
import type { ReservationConflictResponseDto } from '../models';
// @ts-ignore
import type { UpdateOfferComponentInstance409ResponseDto } from '../models';
// @ts-ignore
import type { UpdateOfferInstanceStatus409ResponseDto } from '../models';
/**
 * RestOfferInstancesApi - axios parameter creator
 */
export const RestOfferInstancesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOfferComponentInstanceItem: async (offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerInstanceId' is not null or undefined
            assertParamExists('addOfferComponentInstanceItem', 'offerInstanceId', offerInstanceId)
            // verify required parameter 'offerComponentInstanceId' is not null or undefined
            assertParamExists('addOfferComponentInstanceItem', 'offerComponentInstanceId', offerComponentInstanceId)
            // verify required parameter 'baseOfferComponentInstanceItemDto' is not null or undefined
            assertParamExists('addOfferComponentInstanceItem', 'baseOfferComponentInstanceItemDto', baseOfferComponentInstanceItemDto)
            const localVarPath = `/api/offer-instances/{offerInstanceId}/components/{offerComponentInstanceId}/items`
                .replace('{offerInstanceId}', encodeURIComponent(String(offerInstanceId)))
                .replace('{offerComponentInstanceId}', encodeURIComponent(String(offerComponentInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOfferComponentInstanceItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create offer instance from definition
         * @param {string} processId 
         * @param {CreateOfferInstanceRequestDto} createOfferInstanceRequestDto Create offer instance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfferInstance: async (processId: string, createOfferInstanceRequestDto: CreateOfferInstanceRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createOfferInstance', 'processId', processId)
            // verify required parameter 'createOfferInstanceRequestDto' is not null or undefined
            assertParamExists('createOfferInstance', 'createOfferInstanceRequestDto', createOfferInstanceRequestDto)
            const localVarPath = `/api/processes/{processId}/offer-instances`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOfferInstanceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {number} offerComponentInstanceItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfferComponentInstanceItem: async (offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerInstanceId' is not null or undefined
            assertParamExists('deleteOfferComponentInstanceItem', 'offerInstanceId', offerInstanceId)
            // verify required parameter 'offerComponentInstanceId' is not null or undefined
            assertParamExists('deleteOfferComponentInstanceItem', 'offerComponentInstanceId', offerComponentInstanceId)
            // verify required parameter 'offerComponentInstanceItemId' is not null or undefined
            assertParamExists('deleteOfferComponentInstanceItem', 'offerComponentInstanceItemId', offerComponentInstanceItemId)
            const localVarPath = `/api/offer-instances/{offerInstanceId}/components/{offerComponentInstanceId}/items/{offerComponentInstanceItemId}`
                .replace('{offerInstanceId}', encodeURIComponent(String(offerInstanceId)))
                .replace('{offerComponentInstanceId}', encodeURIComponent(String(offerComponentInstanceId)))
                .replace('{offerComponentInstanceItemId}', encodeURIComponent(String(offerComponentInstanceItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get failed offer workflow actions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedOfferWorkflowActions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/offer-workflow-action-events/failed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get offer component assignees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferComponentAssignees: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/offer-component-assignees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get offer instance by id
         * @param {number} offerInstanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferInstance: async (offerInstanceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerInstanceId' is not null or undefined
            assertParamExists('getOfferInstance', 'offerInstanceId', offerInstanceId)
            const localVarPath = `/api/offer-instances/{offerInstanceId}`
                .replace('{offerInstanceId}', encodeURIComponent(String(offerInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get offer instance status allowed transitions
         * @param {number} offerInstanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferInstanceStatusAllowedTransitions: async (offerInstanceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerInstanceId' is not null or undefined
            assertParamExists('getOfferInstanceStatusAllowedTransitions', 'offerInstanceId', offerInstanceId)
            const localVarPath = `/api/offer-instances/{offerInstanceId}/status-allowed-transitions`
                .replace('{offerInstanceId}', encodeURIComponent(String(offerInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The tasks with the offer context, oldest first, for everyone who can read the offer, whatever the task module read rules and role hierarchy say. A hidden task is returned only to a user related to it (creator, assignee or watcher).
         * @summary Get tasks of the offer
         * @param {number} offerInstanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferInstanceTasks: async (offerInstanceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerInstanceId' is not null or undefined
            assertParamExists('getOfferInstanceTasks', 'offerInstanceId', offerInstanceId)
            const localVarPath = `/api/offer-instances/{offerInstanceId}/tasks`
                .replace('{offerInstanceId}', encodeURIComponent(String(offerInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get offer instances for process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferInstances: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getOfferInstances', 'processId', processId)
            const localVarPath = `/api/processes/{processId}/offer-instances`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retry failed offer workflow action
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryOfferWorkflowAction: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('retryOfferWorkflowAction', 'eventId', eventId)
            const localVarPath = `/api/offer-workflow-action-events/{eventId}/retry`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update offer component instance
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {BaseOfferComponentInstanceDto} baseOfferComponentInstanceDto Offer component instance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferComponentInstance: async (offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceDto: BaseOfferComponentInstanceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerInstanceId' is not null or undefined
            assertParamExists('updateOfferComponentInstance', 'offerInstanceId', offerInstanceId)
            // verify required parameter 'offerComponentInstanceId' is not null or undefined
            assertParamExists('updateOfferComponentInstance', 'offerComponentInstanceId', offerComponentInstanceId)
            // verify required parameter 'baseOfferComponentInstanceDto' is not null or undefined
            assertParamExists('updateOfferComponentInstance', 'baseOfferComponentInstanceDto', baseOfferComponentInstanceDto)
            const localVarPath = `/api/offer-instances/{offerInstanceId}/components/{offerComponentInstanceId}`
                .replace('{offerInstanceId}', encodeURIComponent(String(offerInstanceId)))
                .replace('{offerComponentInstanceId}', encodeURIComponent(String(offerComponentInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOfferComponentInstanceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {number} offerComponentInstanceItemId 
         * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferComponentInstanceItem: async (offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerInstanceId' is not null or undefined
            assertParamExists('updateOfferComponentInstanceItem', 'offerInstanceId', offerInstanceId)
            // verify required parameter 'offerComponentInstanceId' is not null or undefined
            assertParamExists('updateOfferComponentInstanceItem', 'offerComponentInstanceId', offerComponentInstanceId)
            // verify required parameter 'offerComponentInstanceItemId' is not null or undefined
            assertParamExists('updateOfferComponentInstanceItem', 'offerComponentInstanceItemId', offerComponentInstanceItemId)
            // verify required parameter 'baseOfferComponentInstanceItemDto' is not null or undefined
            assertParamExists('updateOfferComponentInstanceItem', 'baseOfferComponentInstanceItemDto', baseOfferComponentInstanceItemDto)
            const localVarPath = `/api/offer-instances/{offerInstanceId}/components/{offerComponentInstanceId}/items/{offerComponentInstanceItemId}`
                .replace('{offerInstanceId}', encodeURIComponent(String(offerInstanceId)))
                .replace('{offerComponentInstanceId}', encodeURIComponent(String(offerComponentInstanceId)))
                .replace('{offerComponentInstanceItemId}', encodeURIComponent(String(offerComponentInstanceItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOfferComponentInstanceItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update offer instance status
         * @param {number} offerInstanceId 
         * @param {OfferStatusTransitionRequestDto} offerStatusTransitionRequestDto Offer status transition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferInstanceStatus: async (offerInstanceId: number, offerStatusTransitionRequestDto: OfferStatusTransitionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerInstanceId' is not null or undefined
            assertParamExists('updateOfferInstanceStatus', 'offerInstanceId', offerInstanceId)
            // verify required parameter 'offerStatusTransitionRequestDto' is not null or undefined
            assertParamExists('updateOfferInstanceStatus', 'offerStatusTransitionRequestDto', offerStatusTransitionRequestDto)
            const localVarPath = `/api/offer-instances/{offerInstanceId}/status`
                .replace('{offerInstanceId}', encodeURIComponent(String(offerInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerStatusTransitionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace the offer instance term (event term)
         * @param {number} offerInstanceId 
         * @param {OfferInstanceTermRequestDto} offerInstanceTermRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferInstanceTerm: async (offerInstanceId: number, offerInstanceTermRequestDto: OfferInstanceTermRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerInstanceId' is not null or undefined
            assertParamExists('updateOfferInstanceTerm', 'offerInstanceId', offerInstanceId)
            // verify required parameter 'offerInstanceTermRequestDto' is not null or undefined
            assertParamExists('updateOfferInstanceTerm', 'offerInstanceTermRequestDto', offerInstanceTermRequestDto)
            const localVarPath = `/api/offer-instances/{offerInstanceId}/term`
                .replace('{offerInstanceId}', encodeURIComponent(String(offerInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerInstanceTermRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestOfferInstancesApi - functional programming interface
 */
export const RestOfferInstancesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestOfferInstancesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferComponentInstanceItemIdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOfferComponentInstanceItem(offerInstanceId, offerComponentInstanceId, baseOfferComponentInstanceItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.addOfferComponentInstanceItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create offer instance from definition
         * @param {string} processId 
         * @param {CreateOfferInstanceRequestDto} createOfferInstanceRequestDto Create offer instance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOfferInstance(processId: string, createOfferInstanceRequestDto: CreateOfferInstanceRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferInstanceIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOfferInstance(processId, createOfferInstanceRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.createOfferInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {number} offerComponentInstanceItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOfferComponentInstanceItem(offerInstanceId, offerComponentInstanceId, offerComponentInstanceItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.deleteOfferComponentInstanceItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get failed offer workflow actions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFailedOfferWorkflowActions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FailedOfferWorkflowActionEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFailedOfferWorkflowActions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.getFailedOfferWorkflowActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get offer component assignees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferComponentAssignees(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfferComponentAssigneeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferComponentAssignees(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.getOfferComponentAssignees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get offer instance by id
         * @param {number} offerInstanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferInstance(offerInstanceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferInstanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferInstance(offerInstanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.getOfferInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get offer instance status allowed transitions
         * @param {number} offerInstanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferInstanceStatusAllowedTransitions(offerInstanceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfferAllowedTransitionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferInstanceStatusAllowedTransitions(offerInstanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.getOfferInstanceStatusAllowedTransitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The tasks with the offer context, oldest first, for everyone who can read the offer, whatever the task module read rules and role hierarchy say. A hidden task is returned only to a user related to it (creator, assignee or watcher).
         * @summary Get tasks of the offer
         * @param {number} offerInstanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferInstanceTasks(offerInstanceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfferTaskDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferInstanceTasks(offerInstanceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.getOfferInstanceTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get offer instances for process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferInstances(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfferInstanceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferInstances(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.getOfferInstances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retry failed offer workflow action
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryOfferWorkflowAction(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryOfferWorkflowAction(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.retryOfferWorkflowAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update offer component instance
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {BaseOfferComponentInstanceDto} baseOfferComponentInstanceDto Offer component instance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOfferComponentInstance(offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceDto: BaseOfferComponentInstanceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOfferComponentInstance(offerInstanceId, offerComponentInstanceId, baseOfferComponentInstanceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.updateOfferComponentInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {number} offerComponentInstanceItemId 
         * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOfferComponentInstanceItem(offerInstanceId, offerComponentInstanceId, offerComponentInstanceItemId, baseOfferComponentInstanceItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.updateOfferComponentInstanceItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update offer instance status
         * @param {number} offerInstanceId 
         * @param {OfferStatusTransitionRequestDto} offerStatusTransitionRequestDto Offer status transition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOfferInstanceStatus(offerInstanceId: number, offerStatusTransitionRequestDto: OfferStatusTransitionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferStatusTransitionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOfferInstanceStatus(offerInstanceId, offerStatusTransitionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.updateOfferInstanceStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace the offer instance term (event term)
         * @param {number} offerInstanceId 
         * @param {OfferInstanceTermRequestDto} offerInstanceTermRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOfferInstanceTerm(offerInstanceId: number, offerInstanceTermRequestDto: OfferInstanceTermRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOfferInstanceTerm(offerInstanceId, offerInstanceTermRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferInstancesApi.updateOfferInstanceTerm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestOfferInstancesApi - factory interface
 */
export const RestOfferInstancesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestOfferInstancesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferComponentInstanceItemIdResponseDto> {
            return localVarFp.addOfferComponentInstanceItem(offerInstanceId, offerComponentInstanceId, baseOfferComponentInstanceItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create offer instance from definition
         * @param {string} processId 
         * @param {CreateOfferInstanceRequestDto} createOfferInstanceRequestDto Create offer instance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfferInstance(processId: string, createOfferInstanceRequestDto: CreateOfferInstanceRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferInstanceIdDto> {
            return localVarFp.createOfferInstance(processId, createOfferInstanceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {number} offerComponentInstanceItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOfferComponentInstanceItem(offerInstanceId, offerComponentInstanceId, offerComponentInstanceItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get failed offer workflow actions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedOfferWorkflowActions(options?: RawAxiosRequestConfig): AxiosPromise<Array<FailedOfferWorkflowActionEventDto>> {
            return localVarFp.getFailedOfferWorkflowActions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get offer component assignees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferComponentAssignees(options?: RawAxiosRequestConfig): AxiosPromise<Array<OfferComponentAssigneeDto>> {
            return localVarFp.getOfferComponentAssignees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get offer instance by id
         * @param {number} offerInstanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferInstance(offerInstanceId: number, options?: RawAxiosRequestConfig): AxiosPromise<OfferInstanceDto> {
            return localVarFp.getOfferInstance(offerInstanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get offer instance status allowed transitions
         * @param {number} offerInstanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferInstanceStatusAllowedTransitions(offerInstanceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<OfferAllowedTransitionDto>> {
            return localVarFp.getOfferInstanceStatusAllowedTransitions(offerInstanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * The tasks with the offer context, oldest first, for everyone who can read the offer, whatever the task module read rules and role hierarchy say. A hidden task is returned only to a user related to it (creator, assignee or watcher).
         * @summary Get tasks of the offer
         * @param {number} offerInstanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferInstanceTasks(offerInstanceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<OfferTaskDto>> {
            return localVarFp.getOfferInstanceTasks(offerInstanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get offer instances for process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferInstances(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OfferInstanceDto>> {
            return localVarFp.getOfferInstances(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retry failed offer workflow action
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryOfferWorkflowAction(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.retryOfferWorkflowAction(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update offer component instance
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {BaseOfferComponentInstanceDto} baseOfferComponentInstanceDto Offer component instance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferComponentInstance(offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceDto: BaseOfferComponentInstanceDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOfferComponentInstance(offerInstanceId, offerComponentInstanceId, baseOfferComponentInstanceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} offerInstanceId 
         * @param {number} offerComponentInstanceId 
         * @param {number} offerComponentInstanceItemId 
         * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOfferComponentInstanceItem(offerInstanceId, offerComponentInstanceId, offerComponentInstanceItemId, baseOfferComponentInstanceItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update offer instance status
         * @param {number} offerInstanceId 
         * @param {OfferStatusTransitionRequestDto} offerStatusTransitionRequestDto Offer status transition request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferInstanceStatus(offerInstanceId: number, offerStatusTransitionRequestDto: OfferStatusTransitionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferStatusTransitionResultDto> {
            return localVarFp.updateOfferInstanceStatus(offerInstanceId, offerStatusTransitionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace the offer instance term (event term)
         * @param {number} offerInstanceId 
         * @param {OfferInstanceTermRequestDto} offerInstanceTermRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOfferInstanceTerm(offerInstanceId: number, offerInstanceTermRequestDto: OfferInstanceTermRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOfferInstanceTerm(offerInstanceId, offerInstanceTermRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestOfferInstancesApi - interface
 */
export interface RestOfferInstancesApiInterface {
    /**
     * 
     * @param {number} offerInstanceId 
     * @param {number} offerComponentInstanceId 
     * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferComponentInstanceItemIdResponseDto>;

    /**
     * 
     * @summary Create offer instance from definition
     * @param {string} processId 
     * @param {CreateOfferInstanceRequestDto} createOfferInstanceRequestDto Create offer instance request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createOfferInstance(processId: string, createOfferInstanceRequestDto: CreateOfferInstanceRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferInstanceIdDto>;

    /**
     * 
     * @param {number} offerInstanceId 
     * @param {number} offerComponentInstanceId 
     * @param {number} offerComponentInstanceItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get failed offer workflow actions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFailedOfferWorkflowActions(options?: RawAxiosRequestConfig): AxiosPromise<Array<FailedOfferWorkflowActionEventDto>>;

    /**
     * 
     * @summary Get offer component assignees
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferComponentAssignees(options?: RawAxiosRequestConfig): AxiosPromise<Array<OfferComponentAssigneeDto>>;

    /**
     * 
     * @summary Get offer instance by id
     * @param {number} offerInstanceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferInstance(offerInstanceId: number, options?: RawAxiosRequestConfig): AxiosPromise<OfferInstanceDto>;

    /**
     * 
     * @summary Get offer instance status allowed transitions
     * @param {number} offerInstanceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferInstanceStatusAllowedTransitions(offerInstanceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<OfferAllowedTransitionDto>>;

    /**
     * The tasks with the offer context, oldest first, for everyone who can read the offer, whatever the task module read rules and role hierarchy say. A hidden task is returned only to a user related to it (creator, assignee or watcher).
     * @summary Get tasks of the offer
     * @param {number} offerInstanceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferInstanceTasks(offerInstanceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<OfferTaskDto>>;

    /**
     * 
     * @summary Get offer instances for process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferInstances(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OfferInstanceDto>>;

    /**
     * 
     * @summary Retry failed offer workflow action
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retryOfferWorkflowAction(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update offer component instance
     * @param {number} offerInstanceId 
     * @param {number} offerComponentInstanceId 
     * @param {BaseOfferComponentInstanceDto} baseOfferComponentInstanceDto Offer component instance request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOfferComponentInstance(offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceDto: BaseOfferComponentInstanceDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {number} offerInstanceId 
     * @param {number} offerComponentInstanceId 
     * @param {number} offerComponentInstanceItemId 
     * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update offer instance status
     * @param {number} offerInstanceId 
     * @param {OfferStatusTransitionRequestDto} offerStatusTransitionRequestDto Offer status transition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOfferInstanceStatus(offerInstanceId: number, offerStatusTransitionRequestDto: OfferStatusTransitionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<OfferStatusTransitionResultDto>;

    /**
     * 
     * @summary Replace the offer instance term (event term)
     * @param {number} offerInstanceId 
     * @param {OfferInstanceTermRequestDto} offerInstanceTermRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOfferInstanceTerm(offerInstanceId: number, offerInstanceTermRequestDto: OfferInstanceTermRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestOfferInstancesApi - object-oriented interface
 */
export class RestOfferInstancesApi extends BaseAPI implements RestOfferInstancesApiInterface {
    /**
     * 
     * @param {number} offerInstanceId 
     * @param {number} offerComponentInstanceId 
     * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).addOfferComponentInstanceItem(offerInstanceId, offerComponentInstanceId, baseOfferComponentInstanceItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create offer instance from definition
     * @param {string} processId 
     * @param {CreateOfferInstanceRequestDto} createOfferInstanceRequestDto Create offer instance request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOfferInstance(processId: string, createOfferInstanceRequestDto: CreateOfferInstanceRequestDto, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).createOfferInstance(processId, createOfferInstanceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} offerInstanceId 
     * @param {number} offerComponentInstanceId 
     * @param {number} offerComponentInstanceItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).deleteOfferComponentInstanceItem(offerInstanceId, offerComponentInstanceId, offerComponentInstanceItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get failed offer workflow actions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFailedOfferWorkflowActions(options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).getFailedOfferWorkflowActions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get offer component assignees
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferComponentAssignees(options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).getOfferComponentAssignees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get offer instance by id
     * @param {number} offerInstanceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferInstance(offerInstanceId: number, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).getOfferInstance(offerInstanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get offer instance status allowed transitions
     * @param {number} offerInstanceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferInstanceStatusAllowedTransitions(offerInstanceId: number, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).getOfferInstanceStatusAllowedTransitions(offerInstanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The tasks with the offer context, oldest first, for everyone who can read the offer, whatever the task module read rules and role hierarchy say. A hidden task is returned only to a user related to it (creator, assignee or watcher).
     * @summary Get tasks of the offer
     * @param {number} offerInstanceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferInstanceTasks(offerInstanceId: number, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).getOfferInstanceTasks(offerInstanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get offer instances for process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferInstances(processId: string, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).getOfferInstances(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retry failed offer workflow action
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retryOfferWorkflowAction(eventId: string, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).retryOfferWorkflowAction(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update offer component instance
     * @param {number} offerInstanceId 
     * @param {number} offerComponentInstanceId 
     * @param {BaseOfferComponentInstanceDto} baseOfferComponentInstanceDto Offer component instance request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOfferComponentInstance(offerInstanceId: number, offerComponentInstanceId: number, baseOfferComponentInstanceDto: BaseOfferComponentInstanceDto, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).updateOfferComponentInstance(offerInstanceId, offerComponentInstanceId, baseOfferComponentInstanceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} offerInstanceId 
     * @param {number} offerComponentInstanceId 
     * @param {number} offerComponentInstanceItemId 
     * @param {BaseOfferComponentInstanceItemDto} baseOfferComponentInstanceItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOfferComponentInstanceItem(offerInstanceId: number, offerComponentInstanceId: number, offerComponentInstanceItemId: number, baseOfferComponentInstanceItemDto: BaseOfferComponentInstanceItemDto, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).updateOfferComponentInstanceItem(offerInstanceId, offerComponentInstanceId, offerComponentInstanceItemId, baseOfferComponentInstanceItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update offer instance status
     * @param {number} offerInstanceId 
     * @param {OfferStatusTransitionRequestDto} offerStatusTransitionRequestDto Offer status transition request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOfferInstanceStatus(offerInstanceId: number, offerStatusTransitionRequestDto: OfferStatusTransitionRequestDto, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).updateOfferInstanceStatus(offerInstanceId, offerStatusTransitionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace the offer instance term (event term)
     * @param {number} offerInstanceId 
     * @param {OfferInstanceTermRequestDto} offerInstanceTermRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOfferInstanceTerm(offerInstanceId: number, offerInstanceTermRequestDto: OfferInstanceTermRequestDto, options?: RawAxiosRequestConfig) {
        return RestOfferInstancesApiFp(this.configuration).updateOfferInstanceTerm(offerInstanceId, offerInstanceTermRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

